<script setup lang="ts">
import IcAnimateSpin from '@/components/Icons/IcAnimateSpin.vue'
import IcDownload from '@/components/Icons/IcDownload.vue'
import { printscreen } from '@/utils/screen/printscreen'
import MaintenanceListingSearchBar from './MaintenanceListingSearchBar.vue'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import MaintenanceForm from '../Body/Forms/MaintenanceForm.vue'

const { t } = useI18n()
const isLoading = ref(false)

</script>

<template>
  <div class="flex flex-col px-2 lg:px-8">
    <div class="mb-4 flex flex-col sm:flex-row sm:items-center sm:justify-between">
      <div class="mb-4 flex max-w-lg flex-col sm:mb-0 sm:mr-4 sm:max-w-none">
        <div class="flex items-center gap-8 text-center">
          <h1 class="pb-1 text-left text-title-md2 font-semibold text-black">
            {{ t('maintenance_create.header.title') }}
          </h1>
        </div>

        <p class="max-w-prose text-left font-medium">
          {{ t('maintenance_create.header.subtitle') }}
        </p>
      </div>
    </div>
    <MaintenanceForm />
  </div>
</template>
